/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PostLiffWellnessCheckAnswerRequestRespondMessagesInner } from './PostLiffWellnessCheckAnswerRequestRespondMessagesInner';
import {
    PostLiffWellnessCheckAnswerRequestRespondMessagesInnerFromJSON,
    PostLiffWellnessCheckAnswerRequestRespondMessagesInnerFromJSONTyped,
    PostLiffWellnessCheckAnswerRequestRespondMessagesInnerToJSON,
} from './PostLiffWellnessCheckAnswerRequestRespondMessagesInner';

/**
 * 
 * @export
 * @interface PostLiffWellnessCheckAnswerRequest
 */
export interface PostLiffWellnessCheckAnswerRequest {
    /**
     * 
     * @type {Array<PostLiffWellnessCheckAnswerRequestRespondMessagesInner>}
     * @memberof PostLiffWellnessCheckAnswerRequest
     */
    respondMessages: Array<PostLiffWellnessCheckAnswerRequestRespondMessagesInner>;
    /**
     * 
     * @type {string}
     * @memberof PostLiffWellnessCheckAnswerRequest
     */
    wellnessCheckId: string;
}

/**
 * Check if a given object implements the PostLiffWellnessCheckAnswerRequest interface.
 */
export function instanceOfPostLiffWellnessCheckAnswerRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "respondMessages" in value;
    isInstance = isInstance && "wellnessCheckId" in value;

    return isInstance;
}

export function PostLiffWellnessCheckAnswerRequestFromJSON(json: any): PostLiffWellnessCheckAnswerRequest {
    return PostLiffWellnessCheckAnswerRequestFromJSONTyped(json, false);
}

export function PostLiffWellnessCheckAnswerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostLiffWellnessCheckAnswerRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'respondMessages': ((json['respondMessages'] as Array<any>).map(PostLiffWellnessCheckAnswerRequestRespondMessagesInnerFromJSON)),
        'wellnessCheckId': json['wellnessCheckId'],
    };
}

export function PostLiffWellnessCheckAnswerRequestToJSON(value?: PostLiffWellnessCheckAnswerRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'respondMessages': ((value.respondMessages as Array<any>).map(PostLiffWellnessCheckAnswerRequestRespondMessagesInnerToJSON)),
        'wellnessCheckId': value.wellnessCheckId,
    };
}

